import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { SignUpFormValues } from "./types";

// @ts-expect-error: FIXME: typing issue with promotionCode undefined value
export const validationSchema: yup.SchemaOf<SignUpFormValues> = yup.object().shape({
  email: yup
    .string()
    .email(i18n.t(Translations.SignUpRouteEmailInvalid))
    .required(i18n.t(Translations.SignUpRouteEmailRequired)),
  password: yup.string().required(i18n.t(Translations.SignUpRoutePasswordRequired)),
  promotionCode: yup.string(),
});
